// extracted by mini-css-extract-plugin
export var footer = "styles-module--footer--a2167";
export var link = "styles-module--link--0de5e";
export var login = "styles-module--login--3bc97";
export var paymentSystems = "styles-module--paymentSystems--ebcc8";
export var socials = "styles-module--socials--743b0";
export var text = "styles-module--text--e665b";